import { playLaughSound } from '../lib/laughSound';
import { API_URL } from '../config/api';
import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import io from 'socket.io-client';
import { UserContext } from '../App';

const socket = io(API_URL, { withCredentials: true, autoConnect: false });
export default function VoteHandler({ post_id }) {
  const user = useContext(UserContext);
  const admin = user?.email === 'warigiachegesa@gmail.com';
  const [pop, setPop] = useState(0);
  const [count, setCount] = useState(0);
  const [liked, setLiked] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = () => {
      if (admin) axios.get(`${API_URL}/api/v1/posts/${post_id}`, { withCredentials: true }).then(({data}) => { if (active) setCount(Number(data.postVote) || 0); }).catch(() => {});
    };
    refresh();
    setLiked(false);
    if (user?.email) {
      socket.connect();
      axios.get(`${API_URL}/api/v1/posts/votingStatus`, { params: { userDetails: JSON.stringify({post_id, email:user.email}) }, withCredentials: true }).then(({data}) => { if (active) setLiked(Array.isArray(data) && data.length > 0); }).catch(() => {});
    }
    const updated = data => { if (String(data.post_id) === String(post_id)) refresh(); };
    socket.on('sendVotes', updated);
    return () => { active = false; socket.off('sendVotes', updated); };
  }, [post_id, user?.email, admin]);
  const react = () => {
    if (!liked) { setPop(value => value + 1); playLaughSound(); }
    socket.emit('getVotes', { post_id, email:user.email });
    setLiked(value => !value);
  };
  const emoji = <span key={pop} className={`post-laugh-emoji${pop ? ' is-popping' : ''}`} aria-hidden="true">😂</span>;
  return user?.email ? <button type="button" className="rxns post-laugh-button" aria-label="Laugh at meme" aria-pressed={liked} title={liked ? 'Liked — tap to remove' : 'Laugh at meme'} onClick={react}>{emoji}{liked && <span className="post-laugh-check" aria-hidden="true">✓</span>}{admin && <span className="count">{count}</span>}</button> : <a href="/account" className="rxns post-laugh-button" aria-label="Sign in to laugh at meme">{emoji}</a>;
}
